module.exports = __webpack_public_path__ + "img/test02-1.0a698f16.jpg";